import React from "react";

const Loading = () => {
  return (
    <div>
      <h1>loading...</h1>
    </div>
  );
};

export default Loading;
